import { createContext, use } from 'react';

import type { AppServices } from '@/app/composition';

/** Services de l'application. React 19 : le contexte sert directement de fournisseur. */
export const AppServicesContext = createContext<AppServices | null>(null);

export function useAppServices(): AppServices {
  const services = use(AppServicesContext);
  if (!services) throw new Error('useAppServices doit être utilisé sous <AppServicesContext>.');
  return services;
}
